import { render, staticRenderFns } from "./settings-account-notifications.vue?vue&type=template&id=50bea69c&scoped=true&"
import script from "./settings-account-notifications.vue?vue&type=script&lang=js&"
export * from "./settings-account-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bea69c",
  null
  
)

export default component.exports